import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Intro = _resolveComponent("Intro")!
  const _component_Summary = _resolveComponent("Summary")!
  const _component_Experience = _resolveComponent("Experience")!
  const _component_SideProjects = _resolveComponent("SideProjects")!
  const _component_Education = _resolveComponent("Education")!
  const _component_Certificates = _resolveComponent("Certificates")!
  const _component_KeySkills = _resolveComponent("KeySkills")!

  return (_openBlock(), _createElementBlock("article", null, [
    _createVNode(_component_Intro),
    _createVNode(_component_Summary),
    _createVNode(_component_Experience),
    _createVNode(_component_SideProjects),
    _createVNode(_component_Education),
    _createVNode(_component_Certificates),
    _createVNode(_component_KeySkills)
  ]))
}